<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
    name: 'Files',
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Files',
      // all titles will be injected into this template
      titleTemplate: '%s | Dominion Studio'
    }
  }
</script>
